import {Link} from 'react-router';
import React from 'react';

function isUrl(to) {
  return to && (to.indexOf('http://') === 0 || to.indexOf('https://') === 0);
}

export default class SPLink extends React.Component {

  render() {
    if (isUrl(this.props.to)) {
      let props = Object.assign({}, this.props, {href: this.props.to});
      return <a {...props} />;
    } else {
      return <Link {...this.props} />;
    }
  }
}



// WEBPACK FOOTER //
// ./~/sp-components/components/Link/index.jsx